// Plain CSS animations for the battle page. The user wants these to
// stay as CSS rather than Framer Motion (the rest of the battle FX
// graduated to motion in `logic/motion.ts`).
//
// Durations divide by the `--doi-anim-speed` custom property so the
// admin slider scales them in lock-step with the JS-driven anims.
// Installed by `installBattleAnimations()` at bootstrap.

const CSS = `
:root { --doi-anim-speed: 1; }

/* Keyword icon strip hides for the first stretch of the entry
   animation so icons don't pop into existence before the creature has
   visibly landed at its battle slot. "pointer-events: auto" is
   explicit so hover-to-show tooltips work even during the lunge /
   creature-play animations. */
@keyframes doi-keyword-strip-fade-in {
  0%, 70% { opacity: 0; }
  100% { opacity: 1; }
}
.doi-keyword-strip {
  animation: doi-keyword-strip-fade-in calc(560ms / var(--doi-anim-speed, 1)) cubic-bezier(.2,.9,.2,1) backwards;
  pointer-events: auto;
}
.doi-keyword-strip > * {
  pointer-events: auto;
}
`;

export function installBattleAnimations(): void {
  if (typeof document === "undefined") return;
  const el = document.createElement("style");
  el.setAttribute("data-source", "battle-animations");
  el.textContent = CSS;
  document.head.appendChild(el);
}
